export default "__VITE_ASSET__DLqvdEQR__"